// import { MapsAPILoader } from '@agm/core';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { LocationType } from '../../enums/shared-enums.enum';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { LocationModel } from '@features/customers/models/location.model';
import { ConfigConstant } from '@shared/constants';
import { LocationsApiService } from '@shared-features/services/locations-api.service';
import { LocationAPI } from '@shared-features/services';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss'],
})
export class LocationsComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() locations: LocationModel[] = [];
  @Input() item: any;
  @Input() type: LocationType;
  @Output() locationId = new EventEmitter();
  @Input() title = '';
  @Input() viewMode = false;
  @Input() generalReceiver = false;
  @Input() selectedMapLocation: LocationModel = new LocationModel();
  @Input() enableLocationsView: boolean;
  public latitude: number = ConfigConstant.defaultLatitude;
  public longitude: number = ConfigConstant.defaultLongitude;
  public zoom = 6;
  public selectedLocation: LocationModel = new LocationModel();
  LocationType = LocationType;
  googleMapLoaded = false;

  constructor(
    private locationsApiService: LocationsApiService, 
    private locationAPI: LocationAPI,
    public matDialog: MatDialog,
  ) {
    super();
  }

  ngOnInit(): void {
    this.locationsApiService.loadGoogleMapsApi().then(() => {
      this.googleMapLoaded = true;
    });
    navigator.permissions.query({ name: 'geolocation' }).then((data) => {
      if (data.state === 'denied') {
        this.latitude = ConfigConstant.defaultLatitude;
        this.longitude = ConfigConstant.defaultLongitude;
      }
      return;
    });

    if (!this.locations?.length) {
      // this.mapsAPILoader.load().then(() => {
      //   this.setCurrentLocation();
      // });
    } else {
      this.latitude = this.locations[0].latitude;
      this.longitude = this.locations[0].longitude;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.selectedMapLocation &&
      changes.selectedMapLocation.currentValue !== changes.selectedMapLocation.previousValue
    ) {
      this.locations.forEach((location) =>
        this.selectedMapLocation.id === location.id
          ? (location.selected = true)
          : (location.selected = false)
      );
      this.changeLocation(this.selectedMapLocation.latitude, this.selectedMapLocation.longitude);
    }
  }

  onAddLocation(id: number) {
    this.locations = this.item?.locations;
    this.locationId.emit(id);
  }

  onSelectLocation(item: LocationModel) {
    this.locations.forEach((location) => (location.selected = false));
    this.selectedLocation = item;
    item.selected = true;
    this.changeLocation(item.latitude, item.longitude);
  }

  onSetAsDefault(location: LocationModel) {
    this.selectedLocation = location;

    const body: Partial<LocationModel> = {
      isDefault: true,
      id: location.id,
      shippingType: location.shippingType,
    };

    this.editLocation(body);
  }

  editLocation(location: Partial<LocationModel>) {
    this.load(this.locationAPI.editLocation(location), {
      isLoadingTransparent: true,
    }).subscribe(
      (location) => {
        this.locations.forEach((location) => (location.isDefault = false));
        this.selectedLocation.isDefault = location?.isDefault;
      },
      (error) => {
        this.asyncFeedbackService.showFailureMessage(
          error ? error.errors[0] : this.translate('ErrorMessages.ErrorHappened')
        );
      }
    );
  }

  onUpdateLocation(event) {
    this.selectedLocation = event;
    this.locations.some((location) => {
      if (location.id === event.id) {
        location.city = event.city;
        return true;
      }
    });
  }
  // private methods
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 6;
      });
    }
  }

  private changeLocation(lat, lng) {
    this.latitude = lat;
    this.longitude = lng;
  }
}
